/* import __COLOCATED_TEMPLATE__ from './dynamic-contents-list.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type DynamicContent from 'embercom/models/articles/dynamic-content';
import { ajaxDelete } from 'embercom/lib/ajax';

interface Args {
  dynamicContents: DynamicContent[];
  onEdit?: (dynamicContent: DynamicContent) => void;
  onCreate?: () => void;
  onDelete?: (dynamicContent: DynamicContent) => void;
}

interface Signature {
  Args: Args;
}

export default class DynamicContentsList extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;
  @service declare notificationsService: $TSFixMe;

  @action
  createNew() {
    this.args.onCreate?.();
  }

  @action
  edit(dynamicContent: DynamicContent) {
    this.args.onEdit?.(dynamicContent);
  }

  @action
  async deleteDynamicContent(dynamicContent: DynamicContent) {
    try {
      await ajaxDelete(`/ember/articles/dynamic_contents/${dynamicContent.id}`, {
        app_id: this.appService.app.id,
      });
      dynamicContent.unloadRecord();
      this.args.onDelete?.(dynamicContent);
      this.notificationsService.notifyConfirmation(
        this.intl.t('knowledge-hub.dynamic-contents.delete-confirmation.success'),
      );
    } catch (e: unknown) {
      this.notificationsService.notifyError(
        this.intl.t('knowledge-hub.dynamic-contents.delete-confirmation.error'),
      );
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::DynamicContents::DynamicContentsList': typeof DynamicContentsList;
    'knowledge-hub/dynamic-contents/dynamic-contents-list': typeof DynamicContentsList;
  }
}
